import { render, staticRenderFns } from "./LeisureCompDonghangGameLinks.vue?vue&type=template&id=6b01766f&scoped=true&"
import script from "./LeisureCompDonghangGameLinks.vue?vue&type=script&lang=js&"
export * from "./LeisureCompDonghangGameLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b01766f",
  null
  
)

export default component.exports